import { useEffect, useRef } from 'react'
import type { InfiniteData } from '@tanstack/react-query'
import type { BoxDto } from '../types/generated'
import { trackBoxListViewed } from '../utils/amplitude'

type FilterType = 'all' | 'my' | 'my-votes' | 'finished'

export const useTrackBoxListViewed = (
  data: InfiniteData<{ data: BoxDto[] }> | undefined,
  isFetching: boolean,
  filterType?: FilterType,
) => {
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (
      data?.pages?.[0]?.data &&
      !isFetching &&
      !hasTrackedRef.current &&
      filterType
    ) {
      hasTrackedRef.current = true
      const totalBoxes = data.pages.reduce(
        (total, page) => total + (page.data?.length ?? 0),
        0,
      )
      trackBoxListViewed(filterType, totalBoxes)
    }
  }, [data, filterType, isFetching])
}
